interface Props {
  size?: 'xs' | 'sm' | 'md' | 'lg';
  className?: string;
}

const sizes = {
  xs: 'text-[11px] tracking-[0.22em] gap-[0.28em]',
  sm: 'text-sm    tracking-[0.26em] gap-[0.32em]',
  md: 'text-lg    tracking-[0.30em] gap-[0.36em]',
  lg: 'text-3xl   tracking-[0.34em] gap-[0.40em]',
};

export function LunarGridLogo({ size = 'md', className = '' }: Props) {
  return (
    <span
      className={`font-mono font-bold select-none inline-flex items-baseline ${sizes[size]} ${className}`}
    >
      <span className="text-foreground">LUNAR</span>
      <span className="brand-glow">GRID</span>
    </span>
  );
}
